import styled from 'styled-components';
export const BrandsBarWrapper = styled.div `
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0 36px; 
  background-color: #1F1C1C;
  @media screen and (max-width: 1040px) {
    padding: 0 36px;
  }
`;
export const BrandsBarInnerContainer = styled.div `
  height: 24px;
  display: flex;
  align-items: center;
  max-width: ${props => props.theme.pages.homePage.maxWidth};
  width: 100%;
  margin: 0 auto;
`;
export const BrandIconWrapper = styled.div `
  ${props => props.padding && `padding: ${props.padding};`}
`;
export const ColumnContainer = styled.div `
  background-color: #1F1C1C;
  padding: 20px 15px;
`;
